/**
 * 判断为断网时 toast
 */
const ERROR_NET = '网络不给力，请稍后再试';

/**
 * 程序处理错误
 */
const ERROR_PROCESS = '服务繁忙，请稍后再试';

/**
 * 语音播报失败
 */
const ERROR_TTS = '暂不支持播报该内容';

/**
 * 点击发送失败的消息小红点toast
 */
const ERROR_SEND_ASK = '网络开小差了，请稍后重新发送';

/**
 * ai ppt构建失败的toast
 */
const ERROR_SEND_AIPPT = '服务开小差，请稍后重试';

/**
 * 消息不能选择
 */
const ERROR_MESSAGE_CHOOSE = '该消息不能选择';

/**
 * 不能选择分享到社区消息
 */
const ERROR_MESSAGE_CHOOSE_COMMUNITY = '暂不支持分享视频到社区';
/**
 * 消息超过最大字符数
 */
const ERROR_MESSAGE_LENGTH_MAX = '已超过最大支持字数限制';

/**
 * 消息不是纯文本
 */
const ERROR_MESSAGE_NOT_TEXT = '抱歉，暂时只支持文本生成视频';

/**
 * 音量提示
 */
const CHANGE_VOLUME = '请调大音量后播放';

/**
 * 图片发送失败
 */
const IMAGE_ABNORMAL = '图片异常，请更换重试';

/**
 * 图片命中风控
 */
const IMAGE_UNDER_RISK_CONTROL = '出了点问题，请更换图片';

/**
 * 图片命中风控
 */
const IMAGE_UPLOAD_FAILED = '图片上传失败，请重试';

/**
 * 服务下线
 */
const ERROR_MESSAGE_OFFLINE = '很抱歉，服务已下线';

// toast错误码前缀
const ERR_PRE = '\n错误码：';

const ERR_INVALID_OUTLINE = '此内容已被您删除';

/**
 * | `页面标识`(2位) | `功能模块`(2位) | `错误类型`(1位) | `错误序号`(2位) |
 * | :-----------: | :-----------: | :-----------: | :-----------: |
 * |   CHAT：00    |    SSE：00    |    NET：1     |      01       |
 * |      ...      |  PROMPT：01   |    LOAD：2    |      ...      |
 * |               | CHARACTER：02 |    DATA：3    |               |
 * |               |    NA：03     |               |               |
 *
 * 例子：`0000101`
 *
 */
const ERROR_CODE = {

    CHAT_SSE_NET_01: `${ERR_PRE}0000101`,
    CHAT_SSE_NET_02: `${ERR_PRE}0000102`,
    CHAT_SSE_NET_03: `${ERR_PRE}0000103`,

    CHAT_SSE_LOAD_01: `${ERR_PRE}0000201`,

    CHAT_SSE_DATA_01: `${ERR_PRE}0000301`,
    CHAT_SSE_DATA_02: `${ERR_PRE}0000302`,
    CHAT_SSE_DATA_03: `${ERR_PRE}0000303`,
    CHAT_SSE_DATA_04: `${ERR_PRE}0000304`,

    CHAT_PROMPT_NET_01: `${ERR_PRE}0001101`,

    CHAT_CHARACTER_NET_01: `${ERR_PRE}0002101`,

    CHAT_NA_LOAD_01: `${ERR_PRE}0003201`,
};

export {
    CHANGE_VOLUME,
    ERROR_CODE,
    ERROR_MESSAGE_CHOOSE,
    ERROR_MESSAGE_CHOOSE_COMMUNITY,
    ERROR_MESSAGE_LENGTH_MAX,
    ERROR_MESSAGE_NOT_TEXT,
    ERROR_MESSAGE_OFFLINE,
    ERROR_NET,
    ERROR_PROCESS,
    ERROR_SEND_ASK,
    ERROR_SEND_AIPPT,
    ERROR_TTS,
    IMAGE_ABNORMAL,
    IMAGE_UNDER_RISK_CONTROL,
    IMAGE_UPLOAD_FAILED,
    ERR_INVALID_OUTLINE,
};
